import { toggleDataActive } from "../utils/toggle-dataset"
import { $Q, $Qll } from "../utils/query-selector"
import api from "../services/api"
import { stringToHTML } from "../utils/to-html"
import { variantOnChange } from "./variants-product"
import { setQuantity } from "../utils/input-quantity"
import { btnAddToCart } from "./cart"




/**
* Performs the opening and closing of the modal. 
* Render the inside of the product for the modal
* @author Andres Briñez
*/

/**
* Function that opens and closes the modal
*/

export const openCloseModal = () => {
  toggleDataActive('.modal-button','#product-modal',{ overlay: true })
}

/**
* Function that renders the elements of the product modal
*/

export const renderElements = () => {
  searchProductHandle('.quick-shop-elements')
}

/**
* Performs the search for the elements that activate the rendering
* @param {String} node activator button
* @return Element click event fired
*/
  
function searchProductHandle (node){
  return $Qll(node).forEach(element => {

    element.addEventListener(
      'click', () => {
        dataHandle(element);
      }
   )
  });
}

/**
* Build the products url. Call the {shopifySectionByUrl} function to return the HTML structure with the handle element.
* @param {object} nodeHandle trigger node with its data-handle
*/

async function dataHandle(nodeHandle){

  const dataSet = nodeHandle.dataset.handle
  const dataHandle = `/products/${dataSet}`
  
  $Q('.information-modal-wrapper').innerHTML = '<div class="spinner-container"><div class="spinner"></div></div>'
  
  const htmlResponse = await api.shopifySectionByUrl(dataHandle,'product-modal')

  const query = $Q(".information-section-wrapper", stringToHTML(htmlResponse))

  await updateSection(query);
}

/**
* Calls the functions: 
* {} To capture the variants.
* {} Makes the modification of the amounts
* @param {object} newSection Html component to render
*/

function updateSection(newSection){
  const section = $Q('.information-modal-wrapper');
  
  section.innerHTML = newSection.innerHTML;

  variantOnChange('.modalvariants');
  setQuantity(".quantity-product");
  btnAddToCart(".add-product-cart-modal");
}


